import { render, staticRenderFns } from "./EnigmaHeader.vue?vue&type=template&id=bfa99a18&scoped=true&"
import script from "./EnigmaHeader.vue?vue&type=script&lang=js&"
export * from "./EnigmaHeader.vue?vue&type=script&lang=js&"
import style0 from "./EnigmaHeader.vue?vue&type=style&index=0&id=bfa99a18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa99a18",
  null
  
)

export default component.exports